import { useInventoryUniverse } from '~Components/InventoryUniverse';
import { LocalItem } from '~Types';
import { useState } from 'react';
import { maxItemsQuantity } from '~Scenes/SelfServiceKiosks/Scenes/General';

interface Props {
  id: string;
  cartItems: LocalItem[];
  upsellsQuantity: number;
}

const useItemQuantity = ({ id, cartItems, upsellsQuantity }: Props) => {
  const minValue = 1;
  const [quantity, setQuantity] = useState(minValue);

  const inventory = useInventoryUniverse();
  const inventoryItem = inventory.items.find((item) => item.itemId === id);

  const onChangeQuantity = (value: number) => {
    let result = quantity + value;

    if (result === 0) {
      result = minValue;
    }

    if (typeof inventoryItem?.count === 'number') {
      const itemCartQuantity = cartItems.filter((item) => item.itemId === id).length;
      const maxValue = inventoryItem.count - itemCartQuantity;

      if (result > maxValue) {
        result = maxValue;
      }
    }

    if (cartItems.length + result + upsellsQuantity > maxItemsQuantity) {
      return;
    }

    setQuantity(result);
  };

  return { quantity, onChangeQuantity };
};

export default useItemQuantity;
